"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AdminNotice", {
  enumerable: true,
  get: function get() {
    return _AdminNotice.default;
  }
});
Object.defineProperty(exports, "Tabs", {
  enumerable: true,
  get: function get() {
    return _Tabs.default;
  }
});

var _AdminNotice = _interopRequireDefault(require("./AdminNotice/AdminNotice.js"));

var _Tabs = _interopRequireDefault(require("./Tabs/Tabs.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }